// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"11d474ce","569":"6915fd96","787":"8576811d"}[chunkId] + ".chunk.js";
};